var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.679,
    height: 8.671,
    viewBox: "0 0 15.679 8.671",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Insights",
    transform: "translate(-138.374 -31.827)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    d: "M152.14,35.695a.8.8,0,0,0-.339,1.077,6.171,6.171,0,0,1,.719,2.912.8.8,0,1,0,1.6,0,8.036,8.036,0,0,0-.9-3.67A.79.79,0,0,0,152.14,35.695Z",
    transform: "translate(-0.062 -0.018)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    d: "M149.225,34.181a.795.795,0,0,0,.758-1.4,7.852,7.852,0,0,0-11.61,6.882.8.8,0,1,0,1.6,0,6.267,6.267,0,0,1,9.256-5.485Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    d: "M153.547,32.387a.357.357,0,0,0-.519-.02l-7.341,6.742-.04.04a.8.8,0,1,0,1.176,1.1l6.723-7.362A.35.35,0,0,0,153.547,32.387Z",
    transform: "translate(-0.033 -0.002)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default __webpack_public_path__ + "static/media/insights.8056882c.svg";
export { ForwardRef as ReactComponent };